import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useApp } from "../../contexts/AppContext";

const UserMenu = ({ setShowProfile, onOpenContact }) => {
  const { user, logout, profile } = useAuth();
  const { setView } = useApp();
  const [isOpen, setIsOpen] = useState(false);

  if (!user) return null;

  const isPremium = profile?.is_premium || false;

  const handleProfileClick = () => {
    setShowProfile(true);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-3 p-2 rounded-xl hover:bg-slate-100 transition-all group"
      >
        {/* MODIFICACIÓN: Contenedor relativo para el badge en móvil */}
        <div className="relative">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-indigo-700 flex items-center justify-center text-white font-bold border-2 border-white shadow-lg">
            {user.avatar || profile?.name.charAt(0) || "E"}
          </div>
          {/* Badge exclusivo para móvil */}
          {isPremium && (
            <span className="absolute -top-1.5 -right-1.5 bg-amber-100 text-amber-600 text-[8px] px-1.5 py-0.5 rounded-full border border-amber-200 font-black md:hidden shadow-sm">
              PRO
            </span>
          )}
        </div>

        <div className="hidden md:block text-left">
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
            {profile?.name || "Estudiante"}
            {isPremium && (
              <span className="bg-amber-100 text-amber-600 text-[10px] px-1.5 py-0.5 rounded-full border border-amber-200 font-black">
                PRO
              </span>
            )}
          </p>
          <p className="text-sm font-bold text-slate-800 group-hover:text-blue-600 transition-colors">
            {user.name}
          </p>
        </div>

        <svg
          className={`w-5 h-5 text-slate-400 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-30"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-64 bg-white rounded-2xl shadow-xl border border-slate-200 z-40 animate-slideDown">
            <div className="p-4 border-b border-slate-100">
              <p className="text-xs text-slate-500">Conectado como</p>
              <p className="font-bold text-slate-800">{user.email}</p>
            </div>

            <div className="p-2">
              <button
                onClick={handleProfileClick}
                className="w-full px-4 py-3 text-left text-sm text-slate-700 hover:bg-slate-50 rounded-xl flex items-center gap-3 transition-colors"
              >
                <svg
                  className="w-5 h-5 text-slate-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
                Mi perfil
              </button>

              <button
                onClick={() => {
                  setView("billing");
                  setIsOpen(false);
                }}
                className="w-full px-4 py-3 text-left text-sm text-slate-700 hover:bg-slate-50 rounded-xl flex items-center gap-3 transition-colors"
              >
                <svg
                  className="w-5 h-5 text-slate-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                  />
                </svg>
                Mi Plan
              </button>

              <button
                onClick={() => {
                  onOpenContact(); // Dispara la apertura del modal
                  setIsOpen(false); // Cierra el menú desplegable
                }}
                className="w-full px-4 py-3 text-left text-sm text-slate-700 hover:bg-slate-50 rounded-xl flex items-center gap-3 transition-colors"
              >
                <svg
                  className="w-5 h-5 text-slate-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093v1.5M12 21h.01M12 16h0"
                  />
                </svg>
                Centro de ayuda
              </button>
              <div className="border-t border-slate-100 my-2" />

              <button
                onClick={() => {
                  logout();
                  setIsOpen(false);
                }}
                className="w-full px-4 py-3 text-left text-sm text-red-600 hover:bg-red-50 rounded-xl flex items-center gap-3 transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
                Cerrar sesión
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserMenu;
